import * as React from 'react';
import { StepType } from '../guide';

export interface StepTypeProps {
  field: React.ReactText[];
  value: string;
  onChange: Function;
  canAddBloomStep: boolean;
  canAddPourStep: boolean;
}

export class StepTypeField extends React.Component<StepTypeProps, any> {
  constructor(props: StepTypeProps) {
    super(props);

    this.state = {
      type: props.value,
    };
  }

  componentWillReceiveProps(newProps: StepTypeProps) {
    this.setState({
      type: newProps.value,
    });
  }

  handleClick = (newType: string) => {
    this.props.onChange(this.props.field, newType);

    this.setState({
      type: newType,
    });
  };

  imageClasses(type: StepType): string {
    return [
      'w3 h3 br-100 bw1 ba',
      this.state.type === type ? 'b--gold' : 'b--transparent',
    ].join(' ');
  }

  labelClasses(type: StepType): string {
    return ['ma0 mt2', this.state.type === type ? 'black' : 'black-70'].join(
      ' ',
    );
  }

  get stepTypes(): StepType[] {
    const items: StepType[] = [];

    if (this.props.canAddBloomStep) {
      items.push(StepType.bloom);
    }

    if (this.props.canAddPourStep) {
      items.push(StepType.pour);
    }

    return items.concat([StepType.wait, StepType.stir, StepType.prepare]);
  }

  render() {
    const { field, value } = this.props;
    return (
      <div className="flex flex-wrap justify-center">
        {this.stepTypes.map((type) => (
          <label
            className="db tc mr3 mb2 pointer"
            onClick={() => this.handleClick(type)}
          >
            <img
              className={this.imageClasses(type)}
              src={`/images/steps/${type}.png`}
              alt={type}
            />
            <p className={this.labelClasses(type)}>{type.toUpperCase()}</p>
          </label>
        ))}
      </div>
    );
  }
}

export default StepTypeField;
